// extracted by mini-css-extract-plugin
export default {"section":"SectionBigTitle_section__I7d4V","largePadding":"SectionBigTitle_largePadding__pPC7p"};